import { useMemo } from 'react';

import { ACTIVE_PAYOUT_ORDERS_STATUSES } from 'constants/order.constants';
import { AdditionalOrderColumn, OrdersTab } from 'enums';
import { useOrderQueryFilters } from 'hooks';
import { FilterDefinition, OrderFilters } from 'types';
import { orderUtils } from 'utils';

import { ManageOrdersList } from '../ManageOrderList';

export const ActiveOrders: React.FC = () => {
  useOrderQueryFilters();

  const additionalFilters: FilterDefinition<OrderFilters>[] = useMemo(
    () => [orderUtils.getStatusFilterDefinition(ACTIVE_PAYOUT_ORDERS_STATUSES)],
    [],
  );

  return (
    <ManageOrdersList
      tab={OrdersTab.Active}
      additionalFilters={additionalFilters}
      additionalColumns={[
        AdditionalOrderColumn.StatusActive,
        AdditionalOrderColumn.CustomerRequisites,
        AdditionalOrderColumn.OrderProcessedBy,
        AdditionalOrderColumn.TraderPayment,
      ]}
    />
  );
};
